import styled from "styled-components";

import { mobileOnly } from "_/style/media";

import { type BannerKind } from "./index";

export const Wrapper = styled.div<{ $kind: BannerKind }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 0.75rem 1.5rem;
  background-color: ${(p) => p.theme.toast[p.$kind]};
  color: ${(p) =>
    p.$kind === "danger"
      ? p.theme.color.palette.snowWhite
      : p.theme.color.palette.almostBlack};
  font-size: 0.875rem;

  ${mobileOnly`
    align-items: flex-start;
    flex-direction: column;
  `}
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  min-width: 0;
`;

export const Title = styled.strong`
  font-size: 1rem;
`;

export const Actions = styled.div`
  flex: 0 0 auto;
`;
